import axios from "@/configuration/axios";
import waitFor from "@/utils/waitFor";

export default {
  strict: true,
  namespaced: true,
  state: {
    isInitialized: false,
    organization: null,
    organizations: null,
  },
  getters: {
    isInitialized: state => state.isInitialized,
    organization: state => state.organization,
    organizations: state => state.organizations,
  },
  mutations: {
    setOrganization: (state, payload) => (state.organization = payload),
    setOrganizations: (state, payload) => {
      state.organization = payload ? payload[0] : null;
      state.organizations = payload;
      state.isInitialized = true;
    },
  },
  actions: {
    initialize: async context => {
      await waitFor(() => context.rootGetters["user/isInitialized"]);

      var user = context.rootGetters["user/user"];
      if (!user) {
        context.commit("setOrganizations", null);
        return;
      }

      await axios
        .get(`/v1/users/${user.id}/organizations`)
        .then(res => context.commit("setOrganizations", res.data))
        .catch(() => context.commit("setOrganizations", null));
    },
  },
};
